module.exports = __webpack_public_path__ + "static/media/upload_more.bb421d40.svg";